/* © 2025 Kaitlyn Troxell */
import * as XLSX from 'xlsx';

export const exportTasksToExcel = (tasks, projectName, events, contractors) => {
  // Sort tasks by order (ascending)
  const sortedTasks = [...tasks].sort((a, b) => (a.order || 0) - (b.order || 0));

  // Group tasks by phase, maintaining order
  const groupedTasks = sortedTasks.reduce((acc, task) => {
    const phase = task.phase || 'Other';
    if (!acc[phase]) {
      acc[phase] = [];
    }
    acc[phase].push(task);
    return acc;
  }, {});

  // Get unique phases in the order they appear
  const phaseOrder = [...new Set(sortedTasks.map(t => t.phase || 'Other'))];

  // Create worksheet data
  const worksheetData = [];
  
  // Add header
  worksheetData.push([projectName || 'Construction Tasks']);
  worksheetData.push([]);
  worksheetData.push(['Complete', 'Task', 'Contractor', 'Scheduled Start Date', 'Scheduled End Date', 'Completed Date', 'Notes']);

  // Add tasks by phase in order
  phaseOrder.forEach(phase => {
    worksheetData.push([phase]);
    groupedTasks[phase].forEach(task => {
      // Find contractor name
      const contractor = contractors?.find(c => c.id === task.contractor);
      const contractorName = contractor ? contractor.name : '';

      // Find the calendar event for this task to get scheduled date
      const taskEvent = events?.find(e => e.task_id === task.id);
      const scheduledStartDate = taskEvent?.start ? new Date(taskEvent.start).toLocaleDateString() : '';
      const scheduledEndDate = taskEvent?.end ? new Date(taskEvent.end).toLocaleDateString() : '';

      // find the notes for this event
      const notes = taskEvent?.notes ? taskEvent.notes : '';

      const completedDate = task.completed && task.date_completed 
        ? (task.date_completed.toDate ? task.date_completed.toDate().toLocaleDateString() : new Date(task.date_completed).toLocaleDateString())
        : '';

      worksheetData.push([
        task.completed ? '☑' : '☐',
        task.title,
        contractorName,
        scheduledStartDate,
        scheduledEndDate,
        completedDate,
        notes || ''
      ]);
    });
    worksheetData.push([]); // Empty row between phases
  });

  // Create workbook and worksheet
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(worksheetData);

  // Set column widths
  ws['!cols'] = [
    { wch: 10 },  // Complete column
    { wch: 50 },  // Task column
    { wch: 20 },  // Contractor column
    { wch: 15 },  // Scheduled Date column
    { wch: 15 },  // Completed Date column
    { wch: 30 }   // Notes column
  ];

  XLSX.utils.book_append_sheet(wb, ws, 'Tasks');

  // Generate file
  const now = new Date();
  const timestamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;
  XLSX.writeFile(wb, `construction_tasks_${timestamp}.xlsx`);
};